import ProductListContainer from "../../../components/applications/eCommerce/productList";

const ProductList = () => {
  return <ProductListContainer />;
};

export default ProductList;
